import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
    {
        path: '/lab_samples/:uuid/:print?',
        name: 'PrintLab_samples',
        component: () => import('../views/Lab_samples/Print.vue'),
        meta:{
            title : 'Lab_samples Print',
            showPrevSamples: true,
        }
    },
    {
        path: '/samples/:uuid/:print?',
        name: 'PrintSamples',
        component: () => import('../views/Lab_samples/Print.vue'),
        meta:{
            title : 'Samples Print',
            showPrevSamples: false,
        }
    },
    {
        path: '/pdf/:uuid',
        name: 'PDF',
        component: () => import('../views/Lab_samples/Pdf.vue'),
        meta:{
            title : 'PDF Sample',
        }
    },
    {
        path: '/patient_samples/:patient_uuid/:lab_uuid/:from_sample_uuid',
        name: 'PatientSamples',
        component: () => import('../views/Lab_samples/PatientSamples.vue'),
        meta:{
            title : 'Patient Samples',
        }
    },
    {
        path: '*',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue'),
        meta:{
            title : 'Not found',
        }
    },
    
]
const router = new VueRouter({
    routes,
    mode:'history'
})


export default router